import React, { useState, createContext, lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import "./index.css";
import { SnackbarProvider } from "notistack";

// Static imports (not lazy because used immediately)
import Sidenav from "./componants/Side Navbar/Sidenav";
import Navbar from "./componants/Navbar/Navbar";
import Login from "./componants/Auth/Login";
import Loader from "./componants/Loader/Loader";
import Load from "./componants/Load/Load";
import AppSetting from "./componants/app-setting/AppSetting";
import SinglePayments from "./componants/payments/SinglePayments";

// Lazy-loaded components
const Home = lazy(() => import("./componants/Home/Home"));
const Profile = lazy(() => import("./componants/Profile/Profile"));
const UserManagement = lazy(
  () => import("./componants/userManagement/UserManagement"),
);
const FAQS = lazy(() => import("./componants/FAQ/EmployeeFaq/FAQ"));
const About = lazy(() => import("./componants/About Us/About"));
const Privacy = lazy(() => import("./componants/Privacy Policies/Privacy"));
const Terms = lazy(() => import("./componants/Terms & Condition/Terms"));
const Cards = lazy(() => import("./componants/cards/Cards"));
const HelpAndSupport = lazy(
  () => import("./componants/Help & Support/HelpAndSupport"),
);
const Cases = lazy(() => import("./componants/Cases/Cases"));
const ThankYou = lazy(() => import("./componants/ThankYou/ThankYou"));
const DeepLink = lazy(() => import("./componants/deepLink/DeepLink"));

//payments
const Payments = lazy(() => import("./componants/payments/Payments"));

export const UserContext = createContext();

function App() {
  const [isOpen, setIsOpen] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(() =>
    localStorage.getItem("token") ? true : false,
  );

  const toggleSidenav = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Router basename="/admin-panel">
        <UserContext.Provider value={{ setIsAuthenticated, isAuthenticated }}>
          <Suspense
            fallback={
              <div className="text-center mt-10">
                <Load />
              </div>
            }
          >
            <Routes>
              {/* Always render DeepLink regardless of auth */}
              <Route path="/deep-link/*" element={<DeepLink />} />

              {/* Authenticated Routes */}
              {isAuthenticated ? (
                <Route
                  path="*"
                  element={
                    <AuthenticatedApp
                      isOpen={isOpen}
                      toggleSidenav={toggleSidenav}
                    />
                  }
                />
              ) : (
                <>
                  <Route path="/login" element={<Login />} />
                  <Route path="*" element={<Navigate to="/login" />} />
                </>
              )}
            </Routes>
          </Suspense>
        </UserContext.Provider>
      </Router>
    </SnackbarProvider>
  );
}

const AuthenticatedApp = ({ isOpen, toggleSidenav }) => {
  const location = useLocation();

  return (
    <div className="flex h-screen overflow-y-scroll scrollbar-hidden">
      <Sidenav isOpen={isOpen} />

      <div
        className={`flex-1 transition-all duration-300 ${
          isOpen ? "ml-64" : "ml-0"
        }`}
      >
        <Navbar toggleSidenav={toggleSidenav} isSidenavOpen={isOpen} />

        <Routes location={location}>
          <Route path="/home" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/FAQ" element={<FAQS />} />
          <Route path="/help" element={<About />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/thank_you_card" element={<ThankYou />} />
          <Route path="/terms-conditions" element={<Terms />} />
          <Route path="/card-management" element={<Cards />} />
          <Route path="/help&support" element={<HelpAndSupport />} />
          <Route path="/app-setting" element={<AppSetting />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/payments/:paymentId" element={<SinglePayments />} />
          <Route path="/*" element={<Navigate to="/home" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
